import type React from "react"
import { Box, Container, Typography, Grid } from "@mui/material"
import TestimonialCard from "../molecules/TestimonialCard"

interface Testimonial {
  name: string
  location: string
  testimonial: string
}

const testimonials: Testimonial[] = [
  {
    name: "Priya Sharma",
    location: "Kaggadasapura",
    testimonial:
      "I found an excellent cook through Cooks and Maids within just 2 days. The verification process gave me confidence, and I'm extremely happy with the service.",
  },
  {
    name: "Karthik",
    location: "Whitefield",
    testimonial:
      "After struggling to find a reliable maid for months, I posted my requirement on Cooks and Maids and received multiple responses from verified candidates. Highly recommended!",
  },
  {
    name: "Anjali",
    location: "Jaya Nagar",
    testimonial:
      "The quality of service providers on this platform is exceptional. I was able to hire a cook who perfectly matched my family's dietary preferences. Great experience!",
  },
]

const TestimonialsSection: React.FC = () => {
  return (
    <Box id="testimonials" sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h2" component="h2" gutterBottom>
            What Our Customers Say
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 700, mx: "auto" }}>
            Hear from families who found their perfect match through our platform
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <TestimonialCard
                name={testimonial.name}
                location={testimonial.location}
                testimonial={testimonial.testimonial}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default TestimonialsSection
